import '../css/Footer.css';
import { Link } from 'react-router-dom';

function Footer({content}) {
  return (
    <footer>
      <div className="footer-container">
        {/* A. 왼쪽 섹션 (로고, 회사명, 정책 링크) */}
        <div className="footer-left">
          <div className="footer-logo">
            {/* 이미지에 있는 회색 로고를 사용하려면 파일명을 확인해주세요. */}
            <img src={process.env.PUBLIC_URL + "/img/logo2-1.png"} alt="Spatial Core Logo" />
          </div>
          <div className="footer-info">
            <p className='company-name'>{content.footerCompany}</p>
            <ul>
              {/* Link to 경로는 실제 페이지에 맞게 수정해주세요. */}
              <li><Link>{content.footerLink1}</Link></li>
              <li><Link>{content.footerLink2}</Link></li>
              <li><Link>{content.footerLink3}</Link></li>
            </ul>
          </div>
        </div>

        {/* B. 오른쪽 섹션 (주소, 연락처, 저작권) */}
        <div className="footer-right">
          <p>
            서울 광진구 광나루로 478, 광진경제허브센터 도약관 406호<br />
            ethan@spatialcore.ai<br />
            Copyright © 2023 by Spatial Core Inc.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;